<template>
  <div>
    <base-material-card :renderCard="card" color="secondary" icon="mdi-credit-card-multiple-outline"
      :title="$t('registry_affiliation_card')">
      <v-layout justify-center style="flex-wrap: wrap">
        <v-radio-group class="button-control" row justify-center v-model="filter" @change="loadTable()">
          <v-radio :label="$t('active_f_p')" value="active"></v-radio>
          <v-radio :label="$t('all_f_p')" value="all"></v-radio>
        </v-radio-group>
        <v-btn class="button-control mx-2 my-2" small @click="createTessera" color="primary">{{
          $t("create_affiliation_card") }}</v-btn>
        <v-btn class="button-control mx-2 my-2" v-if="haveEnte" small @click="dialogImport = true" color="secondary">{{
          $t("import_affiliation_card_from_ente") }}</v-btn>
        <v-btn class="button-control mx-2 my-2" v-if="haveEnte" small @click="alignCardPriceFromEnte" color="secondary">{{
          $t("align_price_below_cost_to_ente") }}</v-btn>
      </v-layout>
      <DataTables @editTessera="editTessera" @viewTessera="viewTessera" @copyTessera="copyTessera" :headers="headers"
        :tableData="tableData"></DataTables>
    </base-material-card>
    <edit-tessera ref="gestTesseraDialog" @isUpdated="loadTable"></edit-tessera>
    <v-dialog v-model="dialogImport" width="unset">
      <v-card style="margin: 0px">
        <v-card-title class="justify-center text-h3">
          {{ $t("import_affiliation_card_from_ente") }}
        </v-card-title>
        <v-card-text><v-btn class="mx-2" color="primary" @click="importCardFromEnte()">{{ $t("only_create_missing")
        }}</v-btn>
          <v-btn class="mx-2" color="primary" @click="importCardFromEnte(true)">{{ $t("update_all") }}</v-btn>
          <v-btn class="mx-2" color="error" @click="dialogImport = false">{{ $t("back") }}</v-btn> </v-card-text>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import gestTessera from "@/app/tessere/gestTessera.vue";
import DataTables from "@/components/base/DataTables.vue";
import Swal from "sweetalert2";

export default {
  name: "list-tessere",
  components: {
    DataTables,
    "edit-tessera": gestTessera,
  },
  props: {
    card: true,
  },
  data() {
    return {
      haveEnte: false,
      dialogImport: false,
      filter: "active",
      headers: [
        { text: this.$t("image"), value: "image", type: "image" },
        { text: this.$t("name"), value: "nome" },
        { text: this.$t("active_f_s"), value: "ifActive", type: "icons" },
        { text: this.$t("linked_to_ente"), value: "tesseraEnteDex" },
        { text: this.$t("qualifications"), value: "qualifiche" },
        { text: this.$t("category"), value: "categoria" },
        { text: this.$t("certificate"), value: "certRequired" },
        { text: this.$t("price"), value: "prezzo" },
        { text: this.$t("profit"), value: "iconMargine", type: "icons" },
        { text: this.$t("color"), value: "hexColor", type: "color" },
        {
          text: this.$t("buy_only_after_n_season_short"),
          value: "onlyAfterNumYear",
          type: "numeric",
        },

        {
          text: this.$t("only_executive"),
          value: "iconOnlyDirigenti",
          type: "icons",
        }, {
          text: this.$t("executive"),
          value: "iconIfDirigente",
          type: "icons",
        },
        {
          text: this.$t("technician"),
          value: "iconIfTecnico",
          type: "icons",
        },
        {
          text: this.$t("gift"),
          value: "iconGadgets",
          type: "icons",
        },
        { text: this.$t("discount_number"), value: "sconto", type: "numeric" },
        { text: this.$t("options"), value: "options", type: "buttons" },
      ],
      tableData: [],
    };
  },

  methods: {
    viewTessera(item) {
      this.$refs.gestTesseraDialog.open("VIEW", item.tesId);
    },
    createTessera() {
      this.$refs.gestTesseraDialog.open("ADD", null);
    },
    editTessera(item) {
      this.$refs.gestTesseraDialog.open("EDIT", item.tesId);
    },
    copyTessera(item) {
      this.$refs.gestTesseraDialog.open("ADD", item.tesId);
    },

    loadTable() {
      let _ = this;
      _.haveEnte = window.systemData.haveEnte;
      let url = "/auth/tesseramenti/listTessere";
      if (_.filter === "all") url += "/all";
      _.tableData = [];
      this.chiamataAxios("GET", url).then((response) => {
        // Aggiunge actions e icona validazione
        _.tableData = response.data.tessere.map(function (item) {
          item.qualifiche = item.qualifiche ? item.qualifiche.join(", ") : "";
          item.iconMargine = []
          if (item.margine < 0) {
            item.iconMargine.push({
              icon: "mdi-alert",
              color: "error",
              label: item.margine,
            })
          }
          if (item.margine === 0) {
            item.iconMargine.push({
              icon: "mdi-equal",
              color: "primary"
            })
          }
          if (item.margine > 0) {
            item.iconMargine.push({
              icon: "mdi-cash-plus",
              color: "success",
              label: item.margine,
            })
          }
          item.options = [
            {
              icon: "mdi-magnify",
              color: "green",
              function: "viewTessera",
              text: _.$t("view_affiliation_card"),
            },
            {
              icon: "mdi-pencil",
              color: "primary",
              function: "editTessera",
              text: _.$t("edit_affiliation_card"),
            },
            {
              icon: "mdi-content-copy",
              color: "primary",
              function: "copyTessera",
              text: _.$t("copy_affiliation_card"),
            },
          ];

          if (item.onlyDirigenti === 1)
            item.iconOnlyDirigenti = [{ icon: "mdi-check", color: "green" }];
          if (item.ifDirigente === 1)
            item.iconIfDirigente = [{ icon: "mdi-check", color: "green" }];
          if (item.ifTecnico === 1)
            item.iconIfTecnico = [{ icon: "mdi-check", color: "green" }];
          if (item.idProduct)
            item.iconGadgets = [{ icon: "mdi-check", color: "green" }];
          if (item.attiva === 1)
            item.ifActive = [{ icon: "mdi-check", color: "green" }];
          if (item.enteTesId) item.tesseraEnteDex = item.tesseraEnte.nome;

          switch (item.certRequired) {
            case 1:
              item.certRequired = _.$t("cert_required_warning");
              break;
            case 2:
              item.certRequired = _.$t("cert_required_block");
              break;
            case 3:
              item.certRequired = _.$t("cert_valid_warning");
              break;
            case 4:
              item.certRequired = _.$t("cert_valid_block");
              break;
            default:
              item.certRequired = _.$t("no_cert_required");
              break;
          }
          return item;
        });

      });
    },
    importCardFromEnte(update = false) {
      let _ = this;
      _.chiamataAxios(update ? "POST" : 'PUT', "/auth/tesseramenti/importTessereFromEnte", {
        dialogLoader: true,
        msg: "always",
      }).then((response) => {
        if (response.msg.esito) {
          _.loadTable();
          _.dialogImport = false;
        }
      });
    },
    alignCardPriceFromEnte() {
      let _ = this;
      _.chiamataAxios("PUT", "/auth/tesseramenti/alignCardPriceFromEnte", {
        dialogLoader: true,
        msg: "always",
      }).then((response) => {
        if (response.msg.esito) _.loadTable();
      });
    },
  },
  mounted() {
    this.loadTable();
  },
};
</script>
<style scoped>
.button-control {
  margin-left: 10px;
}
</style>